// Import our custom CSS
import 'slick-carousel/slick/slick.scss';
import '../scss/theme.scss';

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap';
import 'slick-carousel/slick/slick.min';

function navbarBehaviour() {

    var navbar = document.querySelector("header .navbar.js--hideScroll");
    // Trovo l'altezza della navbar

    if (navbar) {
        var navbarHeight = navbar.offsetHeight;

        // Aggiungo l'altezza della navbar come padding all'elemento main
        var mainContent = document.querySelector('main.main-content');
        mainContent.style.paddingTop = navbarHeight + 'px';

        // Salvo la posizione dello scroll verticale
        var prevScrollpos = window.pageYOffset;
        var scrolledDown = false;

        // Evento scroll sull'oggetto window
        window.onscroll = function () {
            var currentScrollPos = window.pageYOffset;

            // Se l'user scrolla +200px si attiva l'effetto
            if (currentScrollPos > 200) {
                scrolledDown = true;
            } else {
                scrolledDown = false;
            }

            if (scrolledDown) {
                if (prevScrollpos > currentScrollPos) {
                    navbar.style.top = '0';
                } else {
                    navbar.style.top = '-' + navbarHeight + 'px';
                }
            }

            prevScrollpos = currentScrollPos;
        };
    }

}

navbarBehaviour();


jQuery(function ($) {

    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        //>=, not <=
        if (scroll >= 150) {
            //clearHeader, not clearheader - caps H
            $("body").addClass("is-scrolled");
        } else {
            $("body").removeClass("is-scrolled");
        }

    }); //missing );

    $(window).scroll(function () {
        scrollFunction();
    });

    // Aggiungi un gestore di eventi per il click del pulsante
    $("#scrollToTopBtn").click(function () {
        scrollToTop();
    });


    $('.navbar a.dropdown-toggle').on('click', function () {
        var $a = $(this);
        if ($a.attr('href')) {
            location.href = $a.attr('href');
        }
    });

    $('.navbar .dropdown').hover(function () {
        if($(window).width() > 992){
            $(this).addClass('show').find('.dropdown-toggle').attr("aria-expanded", "true").parent().find(".dropdown-menu").fadeIn('fast');
        }
    }, function () {
        if($(window).width() > 992){
            $(this).removeClass('show').find('.dropdown-toggle').attr("aria-expanded", "false").parent().find(".dropdown-menu").fadeOut('fast');
        }
    });

    // Network carousel
    $('.network-loop.card-loop ul').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        prevArrow: false,
        nextArrow: false,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });

    // Post carousel
    $('.post-loop ul').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        prevArrow: false,
        nextArrow: false,
        autoplay: false,
        autoplaySpeed: 2000,
        centerMode: false,
    });

    // Sponsor
    $('.sponsor-gallery').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        prevArrow: false,
        nextArrow: false,
        autoplay: true,
        autoplaySpeed: 2000,
    });

    function scrollFunction() {
        var scrollToTopBtn = $("#scrollToTopBtn");

        if ($(window).scrollTop() > 150) {
            scrollToTopBtn.addClass("show");
        } else {
            scrollToTopBtn.removeClass("show");
        }
    }

    function scrollToTop() {
        var scrollToTopBtn = $(window).scrollTop();

        if (scrollToTopBtn > 0) {
            // Utilizza animate() per uno scroll top animato con jQuery
            $("html, body").animate({scrollTop: 0}, 'fast'); // 500 è la durata dell'animazione in millisecondi
        }
    }

    function box_equalizer() {

        // Cache the highest
        var highestBox = 0;

        // Select and loop the elements you want to equalise
        $('.box-equalizer').each(function () {

            // If this box is higher than the cached highest then store it
            if ($(this).height() > highestBox) {
                highestBox = $(this).height();
            }

        });

        // Set the height of all those children to whichever was highest
        $('.box-equalizer', this).height(highestBox);

    }

    box_equalizer();

    $(window).on('resize', function(){
        box_equalizer();
    });

    $('.service-spacer').each(function(){
        console.log('ciao');
        $(this).height($('.service-plus').height());
    });

}); // jQuery End


function addShake() {
    // Seleziona l'elemento per il quale vuoi aggiungere/rimuovere la classe
    var shakeElement = document.querySelector(".shake-horizontal"); // Sostituisci "il-tuo-elemento" con l'ID o la classe del tuo elemento

    // Aggiungi la classe desiderata
    shakeElement.classList.add("animation-shake"); // Sostituisci "la-tua-classe" con la classe che desideri aggiungere

    // Rimuovi la classe dopo un secondo
    setTimeout(function() {
        shakeElement.classList.remove("animation-shake");
    }, 2000); // Il valore 1000 rappresenta il tempo in millisecondi (1 secondo)
}

// Esegui la funzione iniziale
addShake();

// Ripeti il processo ogni 5 secondi
setInterval(addShake, 5000); // Il valore 5000 rappresenta il tempo in millisecondi (5 secondi)